<template>
    <div class="container">
      <modal-grid
        :title="'Lista de Seleccionados'"
        :visible="visibleModal"
        :data="itemsBox"
        :access="'billboards'"
        :alert_message="'Realmente desea eliminar estos datos?'"
        @hide="visibleModal = !visibleModal"
        @deleted="deleted"
      ></modal-grid> 
      <modal-detail
        :visible="visibleModalDetail"
        :title="'Detalle Caja'"
        @hide="visibleModalDetail = !visibleModalDetail"
      ></modal-detail>
      <div class="row">
        <div class="table-responsive">
          <fieldset class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <legend>Encontrar Documento:</legend>
            <!-- <pre>{{ $data }}</pre> -->
            <div class="row p-2">
              <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <b-form-group>
                  <div class="input-container">
                    <b-form-input
                      v-model="codigoCarpeta"
                      placeholder="DUI, DIM, N° de Interno"
                      @keyup.enter="buscarCarpetaCaja"
                      type="text"
                    ></b-form-input>
                    <button
                      class="btn btn-link btn-clear-input"
                      @click="clearInput"
                    >
                      <i class="fa fa-times-circle fa-lg"></i>
                    </button>
                  </div>
                </b-form-group>
              </div>
              <div class="col-sm-12 col-md-2 col-lg-2 col-xl-2">
                <b-button @click="buscarCarpetaCaja" block title="Buscar Documento">
                  <i class="fa fa-search"></i> Buscar
                </b-button> 
              </div>
            </div>
          </fieldset>
          <div class="d-flex flex-sm-row flex-column bg-secondary">
            <div class="mr-auto p-2">
              <b-button @click="visibleModal = true" v-if="itemsBox.length > 0" squared variant="outline-danger" class="mr-2">
                <i class="fa fa-check-square"></i>
                ({{ itemsBox.length }}) Seleccionados
              </b-button>
              <b-button title="Quitar Seleccionados" @click="emptyGridSelected" variant="outline-dark">
                <i class="fa fa-check-square-o"></i>
              </b-button>
              <b-button title="Descargar Lista PDF" @click="pdfListBox" variant="danger" class="ml-2">
                <i class="fa fa-file-pdf-o"></i>
                <span v-if="itemsBox.length > 0">({{ itemsBox.length }})</span>
              </b-button>
              <b-button title="Descargar Lista EXCEL" @click="excelListBox" variant="success" class="ml-2">
                <i class="fa fa-file-excel-o"></i>
                <span v-if="itemsBox.length > 0">({{ itemsBox.length }})</span>
              </b-button>
            </div>
            <div class="p-2">
              <b-button title="Actualizar Tabla" @click="reloadTable" variant="dark" class="mr-2">
                <i class="fa fa-repeat"></i> Recargar
              </b-button>
            </div>
          </div>
          <kendo-datasource
            ref="data-box"
            :schema-total="'meta.total'"
            :schema-data="'data'"
            :transport-read="{ url: `${url}/cajas`, beforeSend: readData }"
            :transport-parameter-map="parameterMap"
            :page-size="10"
            :server-paging="true"
            :server-filtering="true"
            :server-sorting="true"
            :schema-model-fields="dsSchemaFields"
          ></kendo-datasource>
          <kendo-grid
            ref="gridBox"
            :data-source-ref="'data-box'"
            :no-records="true"
            :messages-no-records="'NO EXISTEN RESULTADOS'"
            :groupable="true"
            :filterable="filterableConfig"
            :navigatable="true"
            :pageable-always-visible="true"
            :pageable-page-sizes="[10, 20, 50, 100]"
            :pageable-button-count="3"
            :pageable-responsive="true"
            :pageable-refresh="true"
            :sortable="true"
            :resizable="true"
            @change="onChange"
            @databound="dataBound"
          >
            <kendo-grid-column :selectable="true" :width="30"></kendo-grid-column>
            <kendo-grid-column
              :field="'gestion'"
              :title="'GESTIÓN'"
              :width="80"
              :filterable-cell-operator="'contains'"
              :filterable-cell-suggestion-operator="'contains'"
            ></kendo-grid-column>
            <kendo-grid-column
              :field="'cod_interno'"
              :title="'INTERNO'"
              :width="80"
              :template="templateCode"
              :filterable-cell-operator="'contains'"
              :filterable-cell-suggestion-operator="'contains'"
            ></kendo-grid-column>
            <kendo-grid-column
              :field="'cant_carpetas'"
              :title="'CARP. INICIAL'"
              :width="70"
              :filterable="false"
            ></kendo-grid-column>
            <kendo-grid-column
              :field="'stock_carpetas'"
              :title="'CARP. ACTUAL'"
              :width="70"
              :filterable="false"
            ></kendo-grid-column>
            <kendo-grid-column
              :field="'estado'"
              :title="'ESTADO'"
              :width="70"
              :template="templateState"
              :filterable-cell-show-operators="false"
              :filterable-cell-template="stateFilter"
            ></kendo-grid-column>
            <!-- <kendo-grid-column
              :command="[{className: 'k-grid-detail', name: 'detail', text: '', iconClass: 'fa fa-wpforms', click: detailCaja}]" 
              :width="20"
            ></kendo-grid-column> -->
            <kendo-grid-column
              :command="[{className: 'k-grid-cubi', name: 'cubi', text: '', iconClass: 'fa fa-qrcode', click: downloadCubi}]" 
              :width="20"
            ></kendo-grid-column>
            <kendo-grid-column
              :command="[{className: 'k-grid-edit', name: 'edit', text: '', iconClass: 'fa fa-edit', click: editCaja}]" 
              :width="20"
            ></kendo-grid-column>
          </kendo-grid>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import $ from "jquery"
  import permission from '../../mixins/permission'
  import { mapGetters } from "vuex"
  import { API_URL } from "../../services/config"
  import ModalDetail from "../widgets/Modals/ModalDetail.vue"
  import ModalGrid from "../widgets/Modals/ModalGridSelected.vue"
  import BoxService from '../../services/box.service'
  
  export default {
    data() {
      return {
        url: API_URL,
        dsSchemaFields: {
          gestion: { type: "string" },
          cod_interno: { type: "string" },
          cant_carpetas: { type: "string" },
          stock_carpetas: { type: "string" },
          estado: { type: "string" },
        },
        filterableConfig: {
          mode: "row",
          operators: {
            string: {
              qe: "Es igual a",
              neq: "No es igual a",
              contains: "Contiene",
              doesnotcontain: "No contiene",
              startswitch: "Comienza con",
              endswitch: "Termina en"
            },
            date: {
              lte: "Antes o igual a",
              gte: "Después o igual a"
            }
          }
        },
        visibleModal: false,
        visibleModalDetail: false,
        codigoCarpeta: '',
        showClearButton: false,
      }
    },
  
    computed: {
      ...mapGetters(["itemsBox"])
    },
  
    components: {
      "modal-detail": ModalDetail,
      "modal-grid": ModalGrid
    },
  
    mixins: [permission],
  
    mounted() {
      let grid = this.$refs.gridBox.kendoWidget()
      this.$bus.$on('evn-reload', () => {
        this.$refs.gridBox.kendoWidget().dataSource.filter({})
      })
    },
  
    methods: {
      clearInput() {
        this.codigoCarpeta = ''
      },

      reloadTable() {
        this.$refs.gridBox.kendoWidget().dataSource.filter({})
      },
  
      async downloadCubi(ev) {
        ev.preventDefault()
        this.$store.dispatch("showLoader")
        let gridWidget = this.$refs.gridBox.kendoWidget()
        let tr = $(ev.target).closest('tr')
        let data = gridWidget.dataItem(tr)
        try {
          const response = await BoxService.downloadCubi(data.id)
          if (response.status === 200) {
            let file = new Blob([response.data], {type: 'application/pdf'})
            let fileUrl = URL.createObjectURL(file)
            window.open(fileUrl) 
            this.$store.dispatch("hideLoader")
          }
        } catch (err) {
          this.$store.dispatch("hideLoader")
        }
      },

      editCaja(ev) {
        ev.preventDefault()
        let gridWidget = this.$refs.gridBox.kendoWidget()
        let tr = $(ev.target).closest('tr')
        let data = gridWidget.dataItem(tr)
        this.$emit("edit-box", data)
      },
  
      detailCaja(ev) {
        ev.preventDefault()
        this.visibleModalDetail = true
      },

      async deleted() {
        let data = this.itemsBox.map(item => item.id)
        const response = await BoxService.deleteBox(data)
        if (response.status === 200) {
          this.$store.dispatch("emptyBox")
          this.$refs.gridBox.kendoWidget().dataSource.read()
          this.visibleModal = false
          this.$bus.$emit('success')
          this.$message.success(response.data.message)
          if (response.data.data.length > 0) {
            this.$notification.warning({
              message: 'Nota',
              description: 'Alguno de los items seleccionados no se eliminaron, por que se encuentran en almacén.',
              duration: 10,
            })
          }
        }
      },
  
      templateCode(dataItem) {
        return (
          "<a target='_blank' href='/almacen/cajas/" + dataItem.id +"/carpetas' class='btn btn-link' title='Ver Contenido'>" +
          kendo.htmlEncode(dataItem.cod_interno) +
          "</a>"
        )
      },
  
      templateState(dataItem) {
        switch (dataItem.estado) {
          case "PENDIENTE":
            return (
              "<span class='badge badge-success'>" +
              kendo.htmlEncode(dataItem.estado) +
              "</span>"
            );
            break;
          case "EN ALMACÉN":
            return (
              "<span class='badge badge-danger'>" +
              kendo.htmlEncode(dataItem.estado) +
              "</span>"
            );
            break;
          case "RETIRADA":
            return (
              "<span class='badge badge-warning'>" +
              kendo.htmlEncode(dataItem.estado) +
              "</span>"
            );
            break;
          default:
            return (
              "<span class='badge badge-success'>" +
              kendo.htmlEncode(dataItem.estado) +
              "</span>"
            );
        }
      },
  
      readData: function(xhr) {
        let self = this
        xhr.setRequestHeader("Authorization", "Bearer " + localStorage.getItem("access_token"))
        xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest")
        xhr.setRequestHeader("Accept-Language", "en")
        xhr.setRequestHeader("Accept", "application/json")
        xhr.done(function(data) {
          self.$emit("general", false)
        })
        xhr.fail(function(data) {
          if (data.status === 403) self.$router.push({ path: '/system/403' })
          if (data.status === 401 || data.responseJSON.message == "Unauthenticated.") {
            self.$store.dispatch('responseMessage', {
              type: 'warning',
              text: 'No tiene una sesión activa, por favor vuelva a iniciar sesión.',
              title: 'Sesión Expirada!',
              modal: true
            })
            .then(async() => {
              await self.$store.dispatch('cleanSession')
              self.$router.push({ path: '/system/login' })
            })
          }
        })
      },
  
      stateFilter(element) {
        let condition = [
          { title: "PENDIENTE", id: 0 },
          { title: "EN ALMACÉN", id: 1 },
          { title: "RETIRADA", id: 2 },
        ]

        element.element.kendoDropDownList({
          dataSource: condition,
          dataTextField: "title",
          change: function(e) {},
          valuePrimitive: true,
          dataValueField: "id",
          optionLabel: {
            title: "-Seleccione-",
            id: ""
          }
        })
      },
  
      parameterMap: function(data, type) {
        if (type == "read" && data.filter) {
          let dates = data.filter.filters.filter(
            e => e.operator == "lte" || e.operator == "gte"
          )
          if (dates.length > 0) {
            data.filter.filters.forEach(item => {
              if (dates.includes(item)) {
                item.value = kendo.toString(item.value, "yyyy-MM-dd")
              }
            })
          }
          return data
        } else return data
      },
  
      emptyGridSelected() {
        this.$store.dispatch("emptyBox")
        .then(() => {
          let grid = this.$refs.gridBox.kendoWidget()
          grid.clearSelection()
        })
      },
  
      onChange(e) {
        let vm = this
        let grid = e.sender
        let items = grid.items()
        items.each(function(idx, row) {
          let idValue = grid.dataItem(row).get("id")
          let index = vm.itemsBox.findIndex(x => x.id == idValue)
          if (row.className.indexOf("k-state-selected") >= 0) {
            let {parent, dirty, dirtyFields, _events, _handlers, uid,...obj} = grid.dataItem(row)
            vm.$store.dispatch("setItemBox", obj)
          } else if (index > -1) {
            vm.$store.dispatch("deleteItemBox", index)
          }
        })
      },
  
      dataBound(e) {
        let vm = this
        let grid = e.sender
        let items = grid.items()
        let itemsToSelect = []
        items.each(function(idx, row) {
          let dataItem = grid.dataItem(row).get("id")
          let estado = grid.dataItem(row).get("estado")
          if (estado == 'PENDIENTE') {
              $(this).find(".k-grid-cubi").addClass("k-state-disabled");
          }
          let index = vm.itemsBox.some(item => item.id === dataItem)
          if (index) {
            itemsToSelect.push(row)
          }
        })
  
        e.sender.select(itemsToSelect)
  
        grid.element.on("click", "tbody tr[data-uid] td:nth-child(2)", function(e) {
          let element = e.target || e.srcElement
          let {parent, dirty, dirtyFields, _events, _handlers, uid,...obj} = grid.dataItem($(element).closest("tr"))
          vm.employee = obj
          vm.work_orders = Array.from(obj.work_orders)
          vm.visibleDetail = true
        })
      },

      async buscarCarpetaCaja() {
        if (this.codigoCarpeta!='') {
          this.$refs.gridBox.kendoWidget().dataSource.filter({field: 'code', value: this.codigoCarpeta})
        }
      },
  
      async pdfListBox() {
        this.$store.dispatch("showLoader")
        let data = this.itemsBox.map(item => item.id)
        try {
          const response = await BoxService.pdfListBox({caja: data})
          if (response.status === 200) {
            let file = new Blob([response.data], {type: 'application/pdf'})
            let fileUrl = URL.createObjectURL(file)
            window.open(fileUrl) 
            this.$store.dispatch("hideLoader")
          }
        } catch (err) {
          this.$store.dispatch("hideLoader")
        }
      },
  
      async excelListBox() {
        this.$store.dispatch("showLoader")
        let data = this.itemsBox.map(item => item.id)
        try {
          const response = await BoxService.excelListBox({caja: data})
          if (response.status === 200) {
            let blob = new Blob([response.data])
            let link = document.createElement("a")
            link.href = window.URL.createObjectURL(blob)
            link.download = `lista-cajas.xlsx`
            link.click()
            this.$store.dispatch("hideLoader")
          }
        } catch (err) {
          this.$store.dispatch("hideLoader")
        }
      }
    }
  }
  </script>
  
  <style scoped src="../../assets/css/grid.css"></style>
  <style scoped>
  /* .download {
    background: #868686 !important; 
    border-color: #0a0a0a !important;
  }
  
  .download:hover {
    background: #0a0a0a !important;
  } */
  
  fieldset {
    background-color: #f6f6f6;
    border-radius: 4px;
  }
  
  legend {
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 4px;
    color: #000;
    font-size: 15px;
    font-weight: bold;
    padding: 3px 5px 3px 7px;
    width: auto;
  }

  .btn-clear-input {
    position: absolute;
    top: 35%;
    right: 15px;
    transform: translateY(-50%);
    background: transparent;
    border: none;
    cursor: pointer;
    display: none;
  }

  .input-container:hover .btn-clear-input {
    display: block;
  }
  </style>